import React from "react";
import { useNavigate } from "react-router-dom";

export default function LoginConfirmModal({ isOpen, onClose }) {
    const navigate = useNavigate();


    if (!isOpen) return null;

    return (

        <div
            className="position-fixed top-0 start-0 vh-100 vw-100 d-flex align-items-center justify-content-center bg-dark bg-opacity-50 p-4"
            style={{ zIndex: 9999 }}
        >
            <div
                className="bg-white rounded-4 p-4 position-relative text-center shadow w-100"
                style={{ maxWidth: "340px" }}
            >

                <button
                    type="button"
                    onClick={onClose}
                    className="position-absolute border-0 bg-transparent fs-4 text-muted p-0"
                    style={{ top: "10px", right: "16px", fontWeight: "bold" }}
                >
                    &times;
                </button>

                <div className="mt-3 mb-4">
                    <h5 className="fs-6 fw-bold text-dark mb-2">
                        로그인 후 접근이 가능합니다
                    </h5>
                    <p className="fs-14 text-secondary m-0">
                        로그인하시겠습니까?
                    </p>
                </div>

                <div className="d-flex gap-2">
                    <button
                        type="button"
                        onClick={onClose}
                        className="btn btn-outline-light text-secondary border fw-bold w-100"
                        style={{ height: "44px", fontSize: "14px", borderColor: "#E0E0E0" }}
                    >
                        취소
                    </button>
                    <button
                        type="button"
                        onClick={() => {
                            onClose();
                            navigate("/login");
                        }}
                        className="btn text-white fw-bold w-100"
                        style={{
                            height: "44px",
                            fontSize: "14px",
                            background: "#ff9d2f"
                        }}
                    >
                        확인
                    </button>
                </div>

            </div>
        </div>
    );
}